import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LayerInfo } from '@root/search/models/map.models';
import { select, Store } from '@ngrx/store';
import {
  selectedMapLayer,
  selectLayersLimitReached, selectPremiumLayers
} from '@store/map-layers.selector';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppState } from '@root/app-state.module';
import { SetPremiumLayer } from '@store/search-board/search-board.actions';
import { combineLatest, Observable } from 'rxjs';
import { selectMapZoom } from '@store/search-board/search-board.selector';
import { selectPremiumSearchMinimumZoom } from '@store/user/user.selector';
import { map, shareReplay } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'rlst-map-premium',
  templateUrl: 'map-premium.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['map-premium.component.scss']
})
export class MapPremiumComponent implements OnInit {
  public layersLimitReached: boolean = false;
  public premiumLayers$: Observable<Array<LayerInfo>>;
  public selectedMapLayer$: Observable<Array<LayerInfo>>;
  public premiumMinScaleExceeded$: Observable<boolean>;

  constructor(private readonly store$: Store<AppState>) {}

  public ngOnInit(): void {
    this.premiumLayers$ = this.store$.pipe(select(selectPremiumLayers));

    this.selectedMapLayer$ = this.store$.pipe(
      select(selectedMapLayer)
    );

    this.store$.pipe(
      select(selectLayersLimitReached),
      untilDestroyed(this)
    )
      .subscribe((limitReached: boolean) => this.layersLimitReached = limitReached);

    this.premiumMinScaleExceeded$ = combineLatest([
      this.store$.pipe(select(selectMapZoom)),
      this.store$.pipe(select(selectPremiumSearchMinimumZoom))
    ]).pipe(
      untilDestroyed(this),
      shareReplay(),
      map(([ mapZoom, premiumSearchMinimumZoom ]) => {
        return premiumSearchMinimumZoom > mapZoom;
      })
    );
  }

  public togglePremium(layer: LayerInfo): void {
    this.store$.dispatch(new SetPremiumLayer(layer));
  }

  trackByFn(_: any, item: LayerInfo) {
    return item.layerId;
  }
}
